import React from "react";
import { array } from "prop-types";
import { Link } from "@quintype/components";

import { Standard300x260Container } from "../../../components/rows/ad-free";
import CardImage from "../../atoms/cardimage";
import CustomStoryCard4 from "../../molecules/custom-story-card4";

import "./twoStoryWithAd.m.css";

const TwoStoryWithAd = ({ list }) => {
  const [firstStory, secondStory] = list;

  return (
    <div styleName="wrapper">
      <Link href={firstStory.url} styleName="first-story">
        <CardImage
          story={firstStory}
          aspectRatio={[16, 9]}
          imageType="image16x9"
          widths={[450]}
          eager={true}
          showHeadline={true}
          showStoryTypeIcon
        />
      </Link>

      {/* Display ad only if 2nd story exists else design doesn't look good */}
      {secondStory && (
        <React.Fragment>
          <CustomStoryCard4 story={secondStory} />

          <div styleName="ad">
            <Standard300x260Container id="rightATF" />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

TwoStoryWithAd.propTypes = {
  list: array.isRequired,
};

export default TwoStoryWithAd;
